var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var Header = function () {
	this.$veil = $( document.getElementById( 'veil' ) );
	this.$menuToggle = $( document.getElementById( 'menu-toggle' ) );
	this.$menu = $( document.getElementById( 'mega-menu' ) );
	this.$searchPane = $( document.querySelector( '.search-pane.mobile' ) );
	this.$handlPane = $( document.querySelector( '.mini-cart-pane.mobile' ) );
};

Header.prototype.init = function () {
	var self = this;

	self.$menuToggle.click( function ( e ) {
		e.preventDefault();
		self.$veil.add( self.$menu ).toggleClass( 'open' );
		self.$veil.add( self.$menu ).toggleClass( 'scroll' );
		$( 'html, body' ).toggleClass( 'disable-scroll' );
	} );
};

module.exports = new Header;
